
import produce from "immer"
import { FETCH_RESORT_SUCCESS } from '../actions/types'

const initialState = {
    data: []
};
export default produce((state = initialState, action: { type: any; payload: any; }) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_RESORT_SUCCESS:
            state.data = payload
            break
        default:
            break
    }
    return state;
}) 